<script>
/* eslint-disable */
import { ref } from 'vue';
import { useStore } from 'vuex';
import { REWARD } from '@/store/types';
import rewardApi from '../../apis/reward.api';

export default {
  props: {},
  setup(props) {
    const store = useStore();
    const query = ref(null);

    query.value = rewardApi.useCategorizedUsersQuery();

    if (query.value) {
      store.commit(REWARD.SET_CATEGORIZED_USERS_QUERY, query);
    }

    return { query };
  },
};
</script>
